export const custom_env = {
    dev: {
        api_url: 'http://local.leadgeneration.com/app_dev.php/private/clients/',
        app_name: 'Dev Team'
    },
    'adsnet.adsalsa.com': {
        api_url: 'http://es.adsalsa.com/private/clients/',
        app_name: 'Adsalsa Publicidad S.L.'
    }
};



// WEBPACK FOOTER //
// /var/www/backend/src/app/_custom_enviroment.ts